<template>
    <div>
      <patent-update-fields-list></patent-update-fields-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
  